import { useState, useEffect } from "react";
import { Table, Card } from "antd";
import type { ColumnsType } from "antd/es/table";
import { IPenalty, getGps } from "../services/penalty";
import { mapType } from "../common/Utils";
import { ReferenceCell } from "../components";
import { getStatusTag } from "../components/StatusTag";

// Read-only list of the carrier's GPS penalties (SEN-436): no justification,
// attachment or contest action — the only recourse is email to penali@.
// Like "Penali Sicurezza" it shows no amounts (stakeholder decision,
// 2026-09-03): the carrier sees GPS amounts only on the RDP letter.
// No plates column either (SEN-440, 2026-09-11).
function GpsPenaltiesPage() {
  const [data, setData] = useState<IPenalty[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getGps();
        setData(response.data);
      } catch (error) {
        console.error("Error fetching GPS penalties:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const columns: ColumnsType<IPenalty> = [
    {
      title: "Referenza",
      key: "sennder_reference",
      render: ReferenceCell,
      width: 160,
      sorter: (a, b) =>
        (a.sennder_reference || "").localeCompare(b.sennder_reference || ""),
    },
    {
      title: "Codice Linea",
      key: "line_code",
      render: (penalty: IPenalty) => <p>{penalty.line_code || "-"}</p>,
      width: 120,
      sorter: (a, b) => (a.line_code || "").localeCompare(b.line_code || ""),
    },
    {
      title: "Tipo",
      key: "delay_type",
      render: (penalty: IPenalty) => <p>{mapType(penalty.delay_type || "-")}</p>,
      width: 100,
    },
    {
      title: "Stato",
      key: "status",
      render: (penalty: IPenalty) => getStatusTag(penalty.status || ""),
      width: 200,
    },
  ];

  return (
    <div className="content-wrapper">
      <Card className="table-card">
        <Table
          rowKey="_id"
          loading={loading}
          dataSource={data}
          columns={columns}
          scroll={{ x: "max-content", y: "50vh" }}
        />
      </Card>
    </div>
  );
}

export default GpsPenaltiesPage;
